import { useEffect, useState } from 'react'
import { Container, Row, Col, Navbar, Offcanvas, Nav, Form, Button, Alert, Spinner } from 'react-bootstrap'
import { ConstructorService, Loading, analyticsService } from 'website-lib'
import InputMask from "react-input-mask";

function App() {

  const [website, setWebsite] = useState(undefined)
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [success, setSuccess] = useState(false);

  useEffect(() => {

    analyticsService.pageView('/', 'Página inicial')

    const constructorService = new ConstructorService()

    const fetchData = async () => {
      try {
        // const constructorService = new ConstructorService()
        const website = null // await constructorService.fetchWebsiteFromApi(process.env.REACT_APP_WEBSITE_ID, process.env.REACT_APP_API)

        setWebsite(website)
        console.log('website', website)
      } catch (error) {
        console.error('Erro ao fazer conexão com a API:', error.message)

        try {
          const website = constructorService.fetchWebsiteFromCache()
          
          if (!website) {
            throw new Error('Nenhum cache encontrado')
          }

          console.warn('Usando dados do cache para construção do site')
          setWebsite(website)
        } catch (error) {
          console.error('Erro ao carregar o site: ', error.message)
          setWebsite({ error: true })
        }
      }
    }

    fetchData()
  }, [])

  const handleSubmit = async (e) => {
    e.preventDefault()

    if (loading) return
    setLoading(true)

    if (!formValidate()) {
      setLoading(false)
      return
    }

    setError(false)

    const body = `Novo cadastro via site:
      Nome: ${firstName} ${lastName}
      Email: ${email}
      Celular: ${phone}
      Mensagem: ${message}
    `

    if (!await sendMail(body)) {
      setError(true);
      console.log('Notification sending failed')
      return;
    }

    await new Promise(resolve => setTimeout(resolve, 3000));

    setFirstName('');
    setLastName('');
    setEmail('');
    setPhone('');
    setMessage('');

    setLoading(false);
    setSuccess(true);
  };

  const handleChange = (fn) => (e) => {
    e.target.style.border = '';
    fn(e);
  }

  const formValidate = () => {
    if (!firstName || firstName.length < 3) {
      const fieldName = document.getElementById('formFirstName');
      fieldName.focus();
      fieldName.scrollIntoView({ behavior: 'smooth', block: 'center' });
      fieldName.style.border = '5px solid red';
      return false;
    }

    if (!lastName || lastName.length < 3) {
      const fieldLastName = document.getElementById('formLastName');
      fieldLastName.focus();
      fieldLastName.scrollIntoView({ behavior: 'smooth', block: 'center' });
      fieldLastName.style.border = '5px solid red';
      return false;
    }

    if (!email || !emailValidate(email)) {
      const fieldEmail = document.getElementById('formEmail');
      console.log('fieldEmail', fieldEmail)
      console.log('email', email)
      fieldEmail.focus();
      fieldEmail.scrollIntoView({ behavior: 'smooth', block: 'center' });
      fieldEmail.style.border = '5px solid red';
      return false;
    }

    if (!phone || !phoneValidate(phone)) {
      const fieldPhone = document.getElementById('formPhone');
      fieldPhone.focus();
      fieldPhone.scrollIntoView({ behavior: 'smooth', block: 'center' });
      fieldPhone.style.border = '5px solid red';
      return false;
    }

    if (message === '' || message.length < 10) {
      const fieldMessage = document.getElementById('formMessage');
      fieldMessage.focus();
      fieldMessage.scrollIntoView({ behavior: 'smooth', block: 'center' });
      fieldMessage.style.border = '5px solid red';
      return false;
    }

    return true;
  }

  const phoneValidate = (phone) => {
    return /^\(\d{2}\) \d{5}-\d{4}$/.test(phone)
  }

  const emailValidate = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
  }

  const sendMail = async (data) => {
    const body = createBody(data)
    const response = await fetch(`${process.env.REACT_APP_API_CONTROLLER}/send-mail`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Website-Id': process.env.REACT_APP_WEBSITE_ID,
        'Authorization': `Bearer ${process.env.REACT_APP_API_MAIL_KEY}`
      },
      body: JSON.stringify(body)
    })

    if (response.ok) {
      return true
    } else {
      setError(true);
      return false
    }
  }

  const createBody = (message) => {
    return {
      'senderName': 'Site Nois',
      'sender': 'contato@nois.dev.br',
      'recipientName': 'Site',
      'recipient': 'nois.dev.br@gmail.com',
      'title': 'Nova inscrição via site',
      'message': message,
      'lead': {
        'formId': 29,
        'firstName': firstName,
        'lastName': lastName,
        'email': email,
        'phone': phone
      }
    }
  }

  if (website === undefined) {
    return <Loading />
  }
  
  return (
    <Container fluid>
      <Row>
        <Col lg={12} className='menu'>
          <Navbar expand="lg">
            <Container>
              <Navbar.Brand>
                <div class="brand" aria-hidden="false">
                  <div class="logo-ico" aria-hidden="true">
                    <img alt="NOIS" src="/favicon.ico" className="d-inline-block align-top website-navbar-brand-logo" />
                  </div>
                  <div style={{ color: 'white' }}>
                    <h1>NOIS</h1>
                    <p>Desenvolvimento de software</p>
                  </div>
                </div>
              </Navbar.Brand>
              <Navbar.Toggle aria-controls="offcanvasNavbar-expand"/>
              <Navbar.Offcanvas id="offcanvasNavbar-expand" aria-labelledby="offcanvasNavbarLabel-expand" placement="end">
                <Offcanvas.Header closeButton>
                  <Offcanvas.Title id="offcanvasNavbarLabel-expand"></Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                  <Nav className="w-100">
                    <div className="menu-direita">
                      <Nav.Link href="#servicos">
                        Serviços
                      </Nav.Link>
                      <Nav.Link href="#sobre">
                        Sobre
                      </Nav.Link>
                      <Nav.Link href="#processo">
                        Processo
                      </Nav.Link>
                      <Nav.Link href="#contato">
                        Contato
                      </Nav.Link>
                    </div>
                  </Nav>
                </Offcanvas.Body>
              </Navbar.Offcanvas>
            </Container>
          </Navbar>
        </Col>
        <Col lg={12}>
          <section class="hero container" aria-labelledby="hero-title">
            <div class="hero-grid">
              <div>
                <div class="eyebrow">Soluções sob medida</div>
                <h2 id="hero-title" class="hero-title">Construímos software confiável e escalável para sua empresa.</h2>
                <p class="hero-sub">A <b>NOIS</b> entrega desenvolvimento full-stack, automações, integrações e consultoria técnica com foco em qualidade, performance e entrega contínua.</p>

                <div class="cta-row" style={{marginTop:'18px'}}>
                  <a class="btn" href="#contato" role="button">Solicitar orçamento</a>
                  <a class="btn btn-outline" href="#servicos">Conheça nossos serviços</a>
                </div>
              </div>

              <div class="grid" aria-hidden="false">
                <div class="card">
                  <h3>Full-stack</h3>
                  <p>Front-end, back-end e devops: entregamos aplicações completas com testes e CI/CD.</p>
                </div>
                <div class="card">
                  <h3>Integrações</h3>
                  <p>APIs, microsserviços e integrações com sistemas existentes (ERPs, CRMs, gateways).</p>
                </div>
                <div class="card">
                  <h3>Consultoria técnica</h3>
                  <p>Arquitetura, revisão de código e roadmaps técnicos para escalar seu produto.</p>
                </div>
              </div>
            </div>
          </section>
        </Col>
        <Col lg={12}>
          <section id="servicos" class="section container" aria-labelledby="servicos-title">
            <h2 id="servicos-title">Serviços</h2>
            <p class="muted" style={{maxWidth:'760px'}}>Oferecemos pacotes adaptáveis conforme tamanho do projeto: desde MVPs rápidos até plataformas corporativas com alto tráfego.</p>

            <div class="grid" style={{marginTop:'18px'}}>
              <div class="card">
                <h3>Desenvolvimento Web</h3>
                <p>SPAs, aplicações server-rendered, PWA e comércio eletrônico com foco em performance.</p>
              </div>
              <div class="card">
                <h3>APIs & Microsserviços</h3>
                <p>Design e implementação de APIs seguras, escaláveis e documentadas.</p>
              </div>
              <div class="card">
                <h3>DevOps & Cloud</h3>
                <p>Infraestrutura como código, pipelines e monitoramento para confiabilidade contínua.</p>
              </div>
            </div>
          </section>
        </Col>
        <Col lg={12}>
          <section id="sobre" class="section container" aria-labelledby="sobre-title">
            <h2 id="sobre-title">Sobre a NOIS</h2>
            <div class="two-col" style={{marginTop:'12px'}}>
              <div>
                <p class="muted">Somos comprometidos com entregas claras, código testável e comunicação direta. Trabalhamos com metodologias ágeis e priorizamos ciclos curtos de feedback para reduzir risco e acelerar valor.</p>

                <h3 style={{marginTop:'20px'}}>O que nos diferencia</h3>
                <ul class="muted" style={{paddingLeft:'18px', marginTop:'8px'}}>
                  <li>Foco em qualidade — testes automatizados e revisão de código.</li>
                  <li>Transparência — roadmap claro e entregas iterativas.</li>
                  <li>Escalabilidade — arquiteturas pensadas para crescimento.</li>
                </ul>
              </div>

              <aside aria-label="Nosso processo">
                <h3>Processo</h3>
                <div style={{marginTop:'12px'}}>
                  <div class="process-item">
                    <div class="step-bubble">1</div>
                    <div>
                      <strong>Descoberta</strong>
                      <div class="muted">Mapeamento de requisitos, stakeholders e objetivos.</div>
                    </div>
                  </div>

                  <div class="process-item">
                    <div class="step-bubble">2</div>
                    <div>
                      <strong>Prototipação</strong>
                      <div class="muted">Protótipos e validação rápida com usuários.</div>
                    </div>
                  </div>

                  <div class="process-item">
                    <div class="step-bubble">3</div>
                    <div>
                      <strong>Entrega</strong>
                      <div class="muted">Iterações, testes e deploy com monitoramento.</div>
                    </div>
                  </div>
                </div>
              </aside>
            </div>
          </section>
        </Col>
        <Col lg={12}>
          <section id="contato" class="section container" aria-labelledby="contato-title">
            <Row>
              <Col lg={12}>
                <h2 id="contato-title">Contato</h2>
                <p class="muted">Envie uma mensagem com o escopo ou dúvidas.</p>
              </Col>
              <Col lg={8}>
                <form id="contactForm" noValidate>
                  <Row>
                    <Col lg={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>Nome</Form.Label>
                        <Form.Control
                          id="formFirstName"
                          type="text"
                          placeholder="Digite o seu nome"
                          value={firstName}
                          onChange={handleChange(e => setFirstName(e.target.value))}
                        />
                      </Form.Group>
                    </Col>
                    <Col lg={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>Sobrenome</Form.Label>
                        <Form.Control
                          id="formLastName"
                          type="text"
                          placeholder="Digite o seu sobrenome"
                          value={lastName}
                          onChange={handleChange(e => setLastName(e.target.value))}
                        />
                      </Form.Group>
                    </Col>
                    <Col lg={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>Email</Form.Label>
                        <Form.Control
                          id="formEmail"
                          type="email"
                          placeholder="Digite o seu email"
                          value={email}
                          onChange={handleChange(e => setEmail(e.target.value))}
                        />
                      </Form.Group>
                    </Col>
                    <Col lg={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>Celular</Form.Label>
                        <Form.Control
                          id="formPhone"
                          as={InputMask}
                          mask='(99) 99999-9999'
                          placeholder="(99) 99999-9999"
                          value={phone}
                          onChange={handleChange(e => setPhone(e.target.value))}
                        />
                      </Form.Group>
                    </Col>
                    <Col lg={12}>
                      <Form.Group className="mb-3">
                        <Form.Label>Mensagem</Form.Label>
                        <Form.Control
                          id="formMessage"
                          as="textarea"
                          rows={4}
                          placeholder="Digite a sua mensagem"
                          value={message}
                          onChange={handleChange(e => setMessage(e.target.value))}
                        />
                      </Form.Group>
                    </Col>
                    <Col lg={12}>
                      <div style={{display:'flex', gap:'10px', alignItems:'center', marginTop:'8px'}}>
                        <Button type="button" className="btn-dark" onClick={handleSubmit}>
                          {loading ? (
                            <>
                              <Spinner
                                as="span"
                                animation="border"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                              />{" "}
                              Enviando mensagem...
                            </>
                          ) : (
                            "Enviar mensagem"
                          )}
                        </Button>
                      </div>
                    </Col>
                    <Col lg={12} className='mt-3'>
                      <Alert variant="danger" show={error}>
                        <b>Ops!</b> Ocorreu um erro ao enviar a mensagem. Por favor, tente novamente mais tarde.
                      </Alert>
                      <Alert variant="light" show={success}>
                        Mensagem enviada com sucesso! Entraremos em contato em breve.
                      </Alert>
                    </Col>
                  </Row>
                </form>
              </Col>
              <Col lg={4}>
                <div style={{display:'flex', flexDirection:'column', gap:'12px'}}>
                  <div class="card" style={{padding:'16px'}}>
                    <h3>Nosso contato</h3>
                    <p class="muted">E-mail: <a href="mailto:contato@nois.dev.br">contato@nois.dev.br</a></p>
                  </div>

                  <div class="card" style={{padding:'16px'}}>
                    <h3>Local</h3>
                    <p class="muted">Atuamos remotamente e em projetos presenciais conforme necessidade.</p>
                  </div>
                </div>
              </Col>
            </Row>
          </section>
        </Col>
        <Col lg={12}>
          <footer role="contentinfo">
            <div class="footer-inner">
              <div style={{ width: '100%', textAlign: 'center' }}>
                <strong>NOIS</strong>
                <div class="muted" style={{marginTop:'6px'}}>Desenvolvimento de software — © <span id="year">2025</span></div>
              </div>
            </div>
          </footer>
        </Col>
      </Row>
    </Container>
    // <Router>
    //   <Routes>
    //     <Route element={<MainLayout website={website} />}>
    //       {website.pages.map((page) => (
    //         <Route
    //           key={page.path}
    //           path={page.path}
    //           element={
    //             <PageRenderer
    //               website={website}
    //               page={page}
    //             />
    //           }
    //         />
    //       ))}
    //     </Route>
    //   </Routes>
    // </Router>
  )
}

export default App